// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"4b01e06a","167":"22eeff0d","354":"e160fd38","407":"cf109cd7","422":"fe302290","491":"8c74c892","518":"9dbd595b","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};